export default "__VITE_ASSET__DPDN_Q$M__"